import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-error-page',
  templateUrl: './custom-error-page.component.html',
  styleUrls: ['./custom-error-page.component.css']
})
export class CustomErrorPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
